import React from 'react';
import useSignedUrl from '../../hooks/useSignedUrl';

// Drop-in for <img>, <iframe> and <object> whose source may live in the private S3 bucket.
// as: 'img' (default) | 'iframe' | 'object'
const SignedMedia = ({ src, as = 'img', ...props }) => {
	const signed = useSignedUrl(src);
	if (!src) return null;
	if (!signed) return <span className='text-xs text-gray-500'>Loading document…</span>;
	if (as === 'object') return <object data={signed} {...props} />;
	if (as === 'iframe') return <iframe src={signed} title={props.title || 'document'} {...props} />;
	// eslint-disable-next-line jsx-a11y/alt-text
	return <img src={signed} {...props} />;
};

export default SignedMedia;
